export default {
  // apiPath: 'http://127.0.0.1:8080'
  // apiPath: 'https://crm-release-rjuo53tx6a-as.a.run.app'
  apiPath: 'https://crm-release-rjuo53tx6a-as.a.run.app/'
}